import { render, staticRenderFns } from "./PaymentsReportsNeopag.vue?vue&type=template&id=328459fe&"
import script from "./PaymentsReportsNeopag.vue?vue&type=script&lang=js&"
export * from "./PaymentsReportsNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports